import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { GestaoUserTerceiroComponent } from './gestao-user-terceiro.component';
import { CadastroUserTerceiroComponent } from './user-terceiro/cadastro-user-terceiro/cadastro-user-terceiro.component';
import { CadastroAdminGrupoComponent } from './admin-grupo/cadastro-admin-grupo/cadastro-admin-grupo.component';
import { ListaUserTerceiroComponent } from './user-terceiro/lista-user-terceiro/lista-user-terceiro.component';
import { ListaAdminGrupoComponent } from './admin-grupo/lista-admin-grupo/lista-admin-grupo.component';
import { TelaGrupoMenusComponent } from './admin-grupo/tela-grupo-menus/tela-grupo-menus.component';
import { ListaAssociarUserTerceiroGrupoComponent } from './associar-user-terceiro/lista-associar-user-terceiro-grupo/lista-associar-user-terceiro-grupo.component';
import { AssociarUserTerceiroGrupoComponent } from './associar-user-terceiro/associar-user-terceiro-grupo/associar-user-terceiro-grupo.component';
import { AuthGuardService } from '../../shared/filters/auth-guard.service';

const routes: Routes = [{
  path: '',
  component: GestaoUserTerceiroComponent,
  children: [
    {
      path: 'cadastro-user-terceiro',
      component: CadastroUserTerceiroComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CADASTRO_DE_USUARIO_TERCEIRO'] }
    },
    {
      path: 'cadastro-user-terceiro/:id',
      component: CadastroUserTerceiroComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CADASTRO_DE_USUARIO_TERCEIRO'] }
    },
    {
      path: 'lista-user-terceiro',
      component: ListaUserTerceiroComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['CADASTRO_DE_USUARIO_TERCEIRO'] }
    },
    {
      path: 'cadastro-admin-grupo',
      component: CadastroAdminGrupoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ADMINISTRACAO_GRUPO'] }
    },
    {
      path: 'cadastro-admin-grupo/:id',
      component: CadastroAdminGrupoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ADMINISTRACAO_GRUPO'] }
    },
    {
      path: 'lista-admin-grupo',
      component: ListaAdminGrupoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ADMINISTRACAO_GRUPO'] }
    },
    {
      path: 'tela-grupo-menus',
      component: TelaGrupoMenusComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ADMINISTRACAO_GRUPO'] }
    },
    {
      path: 'tela-grupo-menus/:id/:produtoId',
      component: TelaGrupoMenusComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ADMINISTRACAO_GRUPO'] }
    },
    {
      path: 'associar-user-terceiro-grupo',
      component: AssociarUserTerceiroGrupoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ASSOCIAR_USUARIO_TERCEIRO_GRUPO'] }
    },
    {
      path: 'associar-user-terceiro-grupo/:id',
      component: AssociarUserTerceiroGrupoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ASSOCIAR_USUARIO_TERCEIRO_GRUPO'] }
    },
    {
      path: 'lista-associar-user-terceiro-grupo',
      component: ListaAssociarUserTerceiroGrupoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ASSOCIAR_USUARIO_TERCEIRO_GRUPO'] }
    },
    {
      path: 'lista-associar-user-terceiro-grupo/:id',
      component: ListaAssociarUserTerceiroGrupoComponent,
      canActivate: [AuthGuardService],
      data: { roles: ['ASSOCIAR_USUARIO_TERCEIRO_GRUPO'] }
    },

  ],

}];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
})
export class GestaoUserTerceiroRoutingModule { }

export const routedComponents = [
  GestaoUserTerceiroComponent,
  CadastroUserTerceiroComponent,
  CadastroAdminGrupoComponent,
  ListaAdminGrupoComponent,
];
